/**
 * Determines the 'from' navigation state when navigating to a page.
 *
 * If navigating to the same page we're already on, preserve the existing 'from' state
 * to maintain the original referrer. Otherwise, use the current pathname as the 'from' value.
 *
 * @param targetPath - The path we're navigating to
 * @param currentPathname - The current location pathname
 * @param existingFromState - The existing 'from' value in location.state (if any)
 * @returns The 'from' value to use in navigation state
 */
export const getNavigationFromState = (
	targetPath: string,
	currentPathname: string,
	existingFromState?: string,
): string => {
	const isNavigatingToCurrentPage = currentPathname === targetPath;
	return isNavigatingToCurrentPage ? (existingFromState ?? currentPathname) : currentPathname;
};
